import { parse, format } from 'date-fns';

// eslint-disable-next-line import/prefer-default-export
export const reformatDateString = ({
  value,
  beforeFormat,
  afterFormat,
}: {
  value: string;
  beforeFormat: string;
  afterFormat: string;
}): string => {
  const asDate = parse(value, beforeFormat, new Date());
  return format(asDate, afterFormat);
};
